import { QueryClient } from "@tanstack/react-query";

/**
 * Общие настройки серверного стейта. `staleTime` в минуту убирает
 * перезапросы при переключении разделов витрины; ошибки 4xx не ретраятся —
 * повтор запрещённого запроса бессмыслен.
 */
export function createQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 60_000,
				gcTime: 5 * 60_000,
				refetchOnWindowFocus: false,
				retry: (failureCount, error) => {
					const status = (error as { data?: { httpStatus?: number } }).data?.httpStatus;
					if (status && status >= 400 && status < 500) return false;
					return failureCount < 2;
				},
			},
			mutations: { retry: false },
		},
	});
}
